export class APIHeaders {
  static fetchHeaders = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
  }

  static fetchHeadersWithAuth(token: any) {
      return {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
      }
  }
}